import { render } from "./Team.vue?vue&type=template&id=15e0a966&scoped=true"
import script from "./Team.vue?vue&type=script&lang=js"
export * from "./Team.vue?vue&type=script&lang=js"

import "./Team.vue?vue&type=style&index=0&id=15e0a966&scoped=true&lang=css"

import exportComponent from "/var/www/admin_web_aaac/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-15e0a966"]])

export default __exports__